<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Usuários</h2>

          <b-form-group
            label="Pesquisa"
            label-for="filterInput"
            class="mt-4"
          >
            <b-input-group>
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Digite para pesquisar"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-table striped hover
            class="mt-4"
            :items="items"
            :fields="fields"
            :filter="filter"
            primary-key="id"
            sort-icon-left
            responsive="md"
          >

            <template v-slot:cell(avatar)="data">
              <div>
                <b-avatar :variant="data.item.last_login.active_now ? 'success' : 'danger'"
                  :text="getInitials(data.item.name)"
                  v-b-tooltip.hover.left :title="data.item.last_login.active_now ? 'Ativo agora' : ''"
                  :badge="String(data.item.total_events)"
                  badge-variant="dark"
                >
                </b-avatar>
              </div>
            </template>

            <template v-slot:cell(actions)="data">
              <div>
                <b-button class="mr-1" @click="copyVipLink(data.item)" v-b-tooltip.hover title="Copiar link VIP da loja">
                  <icon name="link" class="mx-0"></icon>
                </b-button>

                <b-button class="mr-1" @click="openEvents(data.item.id, data.item.name)" v-b-tooltip.hover title="Gerenciar eventos">
                  <icon name="tasks" class="mx-0"></icon>
                </b-button>

                <b-button class="mr-1" @click="openLoginHistory(data.item.id, data.item.name)" v-b-tooltip.hover title="Histórico de acessos">
                  <icon name="history" class="mx-0"></icon>
                </b-button>

                <b-button class="mr-1" @click="openEditUser(data.item.id, data.item.name)" v-b-tooltip.hover title="Editar usuário">
                  <icon name="user" class="mx-0"></icon>
                </b-button>

                <b-button variant="danger" @click="generateNewPassword(data.item.id, data.item.name)" v-b-tooltip.hover title="Gerar nova senha">
                  <icon name="key" class="mx-0"></icon>
                </b-button>
              </div>
            </template>

            <template v-slot:cell(action_status)="data">
              <div>
                <toggle-button
                  :value="data.item.enabled"
                  :sync="true" :width="60" :height="30"
                  :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                  @change="switchEnabled(data.item.id)"
                />
              </div>
            </template>

          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'
import copy from 'copy-to-clipboard'

const slugify = require('slugify')

export default {
  name: 'AdminUsersList',
  components: {
    ToggleButton
  },
  data () {
    return {
      filter: '',
      fields: [
        {key: 'avatar', label: ''},
        {key: 'login', label: 'CPF', class: 'text-nowrap'},
        {key: 'name', label: 'Nome'},
        {key: 'last_login.at', label: 'Último acesso', formatter: 'lastLoginAt'},
        {key: 'last_login.from', label: 'Local último acesso', formatter: 'lastLoginFrom'},
        {key: 'last_login.user_agent', label: '💻 Último dispositivo', formatter: this.$options.filters.userAgent},
        {key: 'action_status', label: 'Habilitado?', class: 'text-center'},
        {key: 'actions', label: '⚙ Ações', class: 'text-nowrap'}
      ],
      items: [],
      sortBy: 'last_login.at',
      sortDesc: true
    }
  },
  async created () {
    await this.getUsers()
  },
  methods: {
    lastLoginAt (at) {
      if (!at) {
        return '-'
      }
      return this.$moment(at).fromNow()
    },
    lastLoginFrom (from) {
      if (!from) {
        return '-'
      }
      return from
    },
    async getUsers () {
      try {
        let users = await this.$http.get(process.env.VUE_APP_URL_APP + '/b/admin/users?role=organizer')
        this.items = users.body.users
      } catch (err) {
        console.error(err)
      }
    },
    getInitials (value) {
      const splited = this.$_.split(value, ' ', 2)
      const initials = this.$_.map(splited, v => v.charAt(0))
      return this.$_.join(initials, '')
    },
    openLoginHistory (id, name) {
      return this.$router.push({name: 'AdminUsersLoginHistory', params: { id: id, username: name }})
    },
    openEvents (id, name) {
      return this.$router.push({name: 'AdminUsersEvents', params: { id: id, username: name }})
    },
    async switchEnabled (userId) {
      let url = process.env.VUE_APP_URL_APP + `/b/admin/users/${userId}/status`

      try {
        let res = await this.$http.put(url, {})
        let j = this.$_.findIndex(this.items, o => o.id === userId)
        this.items[j].enabled = res.body.enabled
      } catch (e) {
        console.error(e)
      }
      return true
    },
    async openEditUser (id, name) {
      return this.$router.push({name: 'AdminUsersEdit', params: { id: id, username: name }})
    },
    vipLink (user) {
      const userSlug = user.id + '-' + slugify(user.name, { lower: true })
      return process.env.VUE_APP_URL_LOJA + '/vip/' + userSlug
    },
    copyVipLink (user) {
      copy(this.vipLink(user))

      this.$bvToast.toast(`Link VIP da loja copiado com sucesso`, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: 'success'
      })
    },
    async generateNewPassword (id, name) {
      const action = await this.$bvModal.msgBoxConfirm(`Quer mesmo gerar uma nova senha para ${name}?`, {
        title: '⚠ Atenção',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não ',
        centered: true,
        hideHeaderClose: false
      })

      if (action === false || !action) {
        return false
      }

      try {
        let resp = await this.$http.put(process.env.VUE_APP_URL_APP + `/b/admin/users/${id}/password`)

        await this.$bvModal.msgBoxOk(`${resp.body.pass}`, {
          title: '🔐 Senha gerada, anote:',
          okVariant: 'success',
          okTitle: 'Fechar',
          centered: true,
          bodyClass: ['text-center', 'text-monospace']
        })
        return true
      } catch (err) {
        console.error(err)
      }
      return false
    }
  }
}
</script>
